/* Posterlyy studio: live previews for custom polaroids and split posters.
   Every photo is turned into a JPEG (long side up to 4096 px, upright, quality 92)
   in the browser before it is attached, so phone camera photos (HEIC, huge, rotated)
   upload reliably. They are posted with the add-to-cart form (Shopify stores them as
   line-item file properties). */
(function () {
  'use strict';
  var MAX_BYTES = 19 * 1024 * 1024;      // what we send
  var MAX_RAW = 80 * 1024 * 1024;        // what we are willing to read from the phone
  var MAX_SIDE = 4096;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function money(c) { return '₹' + Math.round(c / 100).toLocaleString('en-IN'); }
  function isImage(f) { return f && /^image\//.test(f.type || '') || /\.(jpe?g|png|webp|heic|heif)$/i.test((f && f.name) || ''); }
  function setFile(input, file) {
    try { var dt = new DataTransfer(); dt.items.add(file); input.files = dt.files; return true; } catch (e) { return false; }
  }

  /* Resolve with a JPEG File (upright, shrunk). If the browser cannot decode the
     photo, resolve with the original so the caller can decide. */
  function normalize(file) {
    return new Promise(function (resolve) {
      function done(blob) {
        if (!blob) { resolve(file); return; }
        var name = ((file && file.name) || 'photo').replace(/\.[^.]+$/, '') + '.jpg';
        try { resolve(new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() })); }
        catch (e) { resolve(file); }
      }
      function draw(src, w, h) {
        if (!w || !h) { resolve(file); return; }
        var s = Math.min(1, MAX_SIDE / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
        var c = document.createElement('canvas');
        c.width = cw; c.height = ch;
        var ctx = c.getContext('2d');
        if (!ctx) { resolve(file); return; }
        ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, cw, ch);
        try { ctx.drawImage(src, 0, 0, cw, ch); } catch (e) { resolve(file); return; }
        if (src && src.close) src.close();
        if (c.toBlob) c.toBlob(done, 'image/jpeg', 0.92); else done(null);
      }
      function viaImg() {
        var u = URL.createObjectURL(file), im = new Image();
        im.onload = function () { draw(im, im.naturalWidth, im.naturalHeight); URL.revokeObjectURL(u); };
        im.onerror = function () { URL.revokeObjectURL(u); resolve(file); };
        im.src = u;
      }
      if (window.createImageBitmap) {
        createImageBitmap(file, { imageOrientation: 'from-image' })
          .then(function (b) { draw(b, b.width, b.height); })
          .catch(viaImg);
      } else viaImg();
    });
  }

  /* ---------------- Polaroids ---------------- */
  function initPolaroids(root) {
    var form = $('[data-studio-form]', root);
    var slots = $$('[data-slot]', root);
    var pick = $('[data-bulk]', root);
    var err = $('[data-err]', root);
    var priceEl = $('[data-price-out]', root);
    var countEl = $('[data-count]', root);
    var grid = $('[data-grid]', root);
    var qtyNote = $('[data-needed]', root);
    var needed = 0;
    var pending = 0;

    function variantInput() { return $('input[name="id"]:checked', root); }
    function setErr(m) { if (err) { err.textContent = m || ''; err.hidden = !m; } }
    function filled() { return slots.filter(function (s, i) { return i < needed && s._file; }).length; }

    function applyPack() {
      var v = variantInput();
      needed = v ? Number(v.dataset.slots) : slots.length;
      slots.forEach(function (s, i) {
        var on = i < needed;
        s.hidden = !on;
        $$('input[name^="properties"]', s).forEach(function (inp) { inp.disabled = !on; });
      });
      if (v && priceEl) priceEl.textContent = money(Number(v.dataset.price));
      refresh();
    }
    function refresh() {
      var f = filled();
      if (countEl) countEl.textContent = f + ' / ' + needed;
      if (qtyNote) qtyNote.textContent = pending ? 'Getting your photos ready…' : (f >= needed ? 'All set. Add to cart.' : (needed - f) + ' more photo' + (needed - f === 1 ? '' : 's') + ' to go');
      $$('[data-slot]', root).forEach(function (s) { s.classList.toggle('has-photo', !!s._file); s.classList.toggle('is-sample', !s._file); });
    }
    function load(slot, file) {
      if (!isImage(file)) { setErr('That file is not an image.'); return Promise.resolve(false); }
      if (file.size > MAX_RAW) { setErr('"' + file.name + '" is too large to read on this phone. Please pick a smaller copy.'); return Promise.resolve(false); }
      var input = $('input[type="file"]', slot);
      pending++; slot.classList.add('is-busy'); refresh();
      return normalize(file).then(function (f) {
        var ok = true;
        if (f.size > MAX_BYTES) { setErr('"' + file.name + '" is over 19 MB. Please pick a smaller copy.'); ok = false; }
        else if (!setFile(input, f)) {
          // Very old browsers cannot swap the file: keep the one the person picked.
          if (input.files[0] === file) f = file;
          else { setErr('Your browser could not attach that photo. Try Chrome or Safari.'); ok = false; }
        }
        if (ok) {
          slot._file = f;
          var img = $('img', slot);
          if (slot._url) URL.revokeObjectURL(slot._url);
          slot._url = URL.createObjectURL(f);
          img.src = slot._url; img.hidden = false;
          setErr('');
        }
        return ok;
      }).then(function (ok) {
        pending--; slot.classList.remove('is-busy'); refresh();
        return ok;
      });
    }
    function restore(slot) { var im = $('img', slot); if (im.dataset.sample) { im.src = im.dataset.sample; im.hidden = false; } else im.hidden = true; }
    slots.forEach(function (slot) {
      var input = $('input[type="file"]', slot);
      input.addEventListener('change', function () {
        if (input.files[0] && input.files[0] !== slot._file) load(slot, input.files[0]);
        else if (!input.files[0]) { slot._file = null; restore(slot); refresh(); }
      });
      var rm = $('[data-remove]', slot);
      if (rm) rm.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        input.value = ''; slot._file = null; restore(slot); refresh();
      });
    });
    function loadMany(files) {
      var free = slots.filter(function (s, i) { return i < needed && !s._file; });
      var chain = Promise.resolve();
      files.slice(0, free.length).forEach(function (f, i) { chain = chain.then(function () { return load(free[i], f); }); });
      if (files.length > free.length) setErr('Only ' + needed + ' photos fit in this pack. Pick a bigger pack for more.');
      return chain;
    }
    if (pick) pick.addEventListener('change', function () {
      var files = Array.prototype.slice.call(pick.files);
      loadMany(files);
      pick.value = '';
    });
    // drag & drop onto the grid
    if (grid) {
      ['dragover', 'dragenter'].forEach(function (ev) { grid.addEventListener(ev, function (e) { e.preventDefault(); grid.classList.add('is-drop'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { grid.addEventListener(ev, function () { grid.classList.remove('is-drop'); }); });
      grid.addEventListener('drop', function (e) {
        e.preventDefault();
        loadMany(Array.prototype.slice.call(e.dataTransfer.files || []));
      });
    }
    // frame + look (live preview)
    $$('input[name="properties[Frame]"]', root).forEach(function (r) {
      r.addEventListener('change', function () { root.setAttribute('data-frame', r.value.toLowerCase()); });
    });
    $$('input[name="properties[Look]"]', root).forEach(function (r) {
      r.addEventListener('change', function () { root.setAttribute('data-look', r.value.toLowerCase().replace(/[^a-z]+/g, '-')); });
    });
    // Pack / lights chips pick the matching hidden variant radio.
    function pickVariant() {
      var p = $('input[name="ui_pack"]:checked', root), l = $('input[name="ui_lights"]:checked', root);
      var lights = l ? l.value : 'off';
      var hit = $$('input[name="id"]', root).filter(function (v) {
        return v.dataset.slots === (p && p.value) && (!l || v.dataset.lights === lights);
      })[0];
      if (hit) hit.checked = true;
      root.setAttribute('data-lights', lights);
      applyPack();
    }
    $$('input[name="ui_pack"], input[name="ui_lights"]', root).forEach(function (r) { r.addEventListener('change', pickVariant); });
    $$('input[name="ui_view"]', root).forEach(function (r) {
      r.addEventListener('change', function () { root.setAttribute('data-view', r.value); });
    });
    $$('input[name="id"]', root).forEach(function (r) { r.addEventListener('change', applyPack); });

    form.addEventListener('submit', function (e) {
      if (pending > 0) {
        e.preventDefault();
        setErr('Your photos are still getting ready. Try again in a moment.');
        return;
      }
      if (filled() < needed) {
        e.preventDefault();
        setErr('Add ' + (needed - filled()) + ' more photo' + (needed - filled() === 1 ? '' : 's') + ' first.');
        var first = slots.filter(function (s, i) { return i < needed && !s._file; })[0];
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var b = $('[type="submit"]', form);
      if (b) { b.disabled = true; b.textContent = 'Uploading photos…'; }
    });
    var sumEl = $('[data-summary]', root);
    function updateSummary() {
      if (!sumEl) return;
      var f = $('input[name="properties[Frame]"]:checked', root), lk = $('input[name="properties[Look]"]:checked', root);
      var l = $('input[name="ui_lights"]:checked', root);
      sumEl.textContent = needed + ' polaroids · ' + (f ? f.value.toLowerCase() : 'white') + ' border · ' + (lk ? lk.value.toLowerCase() : 'original') + ' look' + (l && l.value === 'on' ? ' · with fairy lights' : '');
    }
    $$('input[name="properties[Frame]"], input[name="properties[Look]"], input[name="ui_lights"], input[name="ui_pack"]', root).forEach(function (r) { r.addEventListener('change', updateSummary); });
    pickVariant();
    updateSummary();
    var sticky = $('[data-sticky]', root), hero = $('.pzhero', root), build = $('.build', root), tick = false;
    function stick() {
      tick = false;
      if (!sticky || !hero || !build) return;
      var hb = hero.getBoundingClientRect().bottom, bt = build.getBoundingClientRect().top;
      sticky.classList.toggle('is-on', hb < 80 && bt > window.innerHeight * 0.75);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(stick); } }, { passive: true });
    stick();
  }

  /* ---------------- Split poster ---------------- */
  function initSplit(root) {
    var form = $('[data-studio-form]', root);
    var stage = $('[data-stage]', root);
    var panels = $$('[data-panel]', root);
    var file = $('[data-file]', root);
    var zoomEl = $('[data-zoom]', root);
    var err = $('[data-err]', root);
    var priceEl = $('[data-price-out]', root);
    var cropEl = $('[data-crop]', root);
    var hint = $('[data-hint]', root);
    var img = { w: 1600, h: 1600, url: root.getAttribute('data-demo'), ready: false, demo: true };
    var st = { zoom: 1, fx: 0.5, fy: 0.5 };
    var cache = new Image();
    var busy = false;

    function setErr(m) { if (err) { err.textContent = m || ''; err.hidden = !m; } }
    function layout() {
      var p0 = panels[0].getBoundingClientRect();
      var pw = p0.width, ph = p0.height;
      if (!pw || !ph) return;
      var gap = panels[1].getBoundingClientRect().left - p0.right;
      var tw = 3 * pw + 2 * gap;
      var s0 = Math.max(tw / img.w, ph / img.h), s = s0 * st.zoom;
      var dw = img.w * s, dh = img.h * s;
      var left = -(dw - tw) * st.fx, top = -(dh - ph) * st.fy;
      panels.forEach(function (p, i) {
        p.style.backgroundImage = 'url("' + img.url + '")';
        p.style.backgroundSize = dw + 'px ' + dh + 'px';
        p.style.backgroundPosition = (left - i * (pw + gap)) + 'px ' + top + 'px';
      });
      stage._m = { dw: dw, dh: dh, tw: tw, ph: ph };
      if (cropEl) cropEl.value = 'zoom ' + st.zoom.toFixed(2) + ', x ' + Math.round(st.fx * 100) + '%, y ' + Math.round(st.fy * 100) + '%';
    }
    function useUrl(url, demo) {
      cache.onload = function () {
        img.w = cache.naturalWidth; img.h = cache.naturalHeight; img.url = url; img.demo = !!demo;
        st.zoom = 1; st.fx = 0.5; st.fy = 0.5; if (zoomEl) zoomEl.value = 1;
        root.classList.toggle('has-photo', !demo);
        if (hint) hint.hidden = !demo;
        layout();
      };
      cache.src = url;
    }
    if (file) file.addEventListener('change', function () {
      var f = file.files[0];
      if (!f || f._done) return;
      if (!isImage(f)) { setErr('That file is not an image.'); file.value = ''; return; }
      if (f.size > MAX_RAW) { setErr('That photo is too large to read on this phone. Please pick a smaller copy.'); file.value = ''; return; }
      busy = true; setErr('Getting your photo ready…');
      normalize(f).then(function (n) {
        busy = false;
        if (n.size > MAX_BYTES) { setErr('That photo is over 19 MB. Please pick a smaller copy.'); file.value = ''; return; }
        if (n !== f) {
          n._done = true;
          if (!setFile(file, n)) { n = f; }
        }
        setErr('');
        useUrl(URL.createObjectURL(n), false);
      });
    });
    var drag = null;
    stage.addEventListener('pointerdown', function (e) {
      drag = { x: e.clientX, y: e.clientY, fx: st.fx, fy: st.fy };
      stage.setPointerCapture(e.pointerId); stage.classList.add('is-drag');
    });
    stage.addEventListener('pointermove', function (e) {
      if (!drag || !stage._m) return;
      var m = stage._m, ox = m.dw - m.tw, oy = m.dh - m.ph;
      if (ox > 1) st.fx = Math.min(1, Math.max(0, drag.fx - (e.clientX - drag.x) / ox));
      if (oy > 1) st.fy = Math.min(1, Math.max(0, drag.fy - (e.clientY - drag.y) / oy));
      layout();
    });
    function end() { drag = null; stage.classList.remove('is-drag'); }
    stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
    if (zoomEl) zoomEl.addEventListener('input', function () { st.zoom = Number(zoomEl.value); layout(); });
    $$('[data-nudge]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var d = b.getAttribute('data-nudge');
        if (d === 'center') { st.fx = 0.5; st.fy = 0.5; st.zoom = 1; if (zoomEl) zoomEl.value = 1; }
        layout();
      });
    });
    $$('input[name="id"]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        if (priceEl) priceEl.textContent = money(Number(r.dataset.price));
        root.style.setProperty('--pa', r.dataset.ratio);
        setTimeout(layout, 30);
      });
    });
    $$('[data-wall]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        root.setAttribute('data-wall-tone', b.getAttribute('data-wall'));
        $$('[data-wall]', root).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); setErr('Your photo is still getting ready. Try again in a moment.'); return; }
      if (!file.files[0]) {
        e.preventDefault(); setErr('Choose your photo first.');
        stage.scrollIntoView({ behavior: 'smooth', block: 'center' }); return;
      }
      var b = $('[type="submit"]', form);
      if (b) { b.disabled = true; b.textContent = 'Uploading photo…'; }
    });
    if (window.ResizeObserver) new ResizeObserver(layout).observe(stage); else window.addEventListener('resize', layout);
    var checked = $('input[name="id"]:checked', root);
    if (checked) root.style.setProperty('--pa', checked.dataset.ratio);
    useUrl(img.url, true);
  }

  function boot() {
    $$('[data-polaroid-studio]').forEach(function (r) { if (!r._init) { r._init = 1; initPolaroids(r); } });
    $$('[data-split-studio]').forEach(function (r) { if (!r._init) { r._init = 1; initSplit(r); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
